import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';

export default function Advance({ children, attributes, clientId , alwaysOpen, rowgap}) {
 
    const { mergedStyles, handleMouseEnter, handleMouseLeave,responsiveClasses, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);

    // Apply different styles if alwaysOpen (e.g. FAQ grid layout)
	const additionalClass = alwaysOpen ? 'vb-faq-grid-style' : 'vb-faq-accordian-style';

    const blockProps = useBlockProps({
        className: `block-${clientId} ${hoverAnimationClass} ${responsiveClasses} ${additionalClass}`,
        style: {...mergedStyles, marginTop: rowgap},
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });

    return (
        <div {...blockProps} >
            {children}
        </div>
    );
}